export default __webpack_public_path__ + "static/media/logo_udp_light.b540dee2.png";